import PassengerFormTable from './PassengerFormTable';
import { withRouter } from 'react-router';

export default withRouter(PassengerFormTable);
